import moment from "moment";
import React, { useState } from "react";
import { SingleDatePicker } from "react-dates";
import styled, { css } from "styled-components";
import CalendarIcon from "sweet-web/components/icons/CalendarIcon";
import CrossIcon from "sweet-web/components/icons/CrossIcon";
import { globalInputStyles } from "sweet-web/components/universal/Input";
import { ItemTitle } from "sweet-web/components/universal/Text";
import { colors } from "sweet-web/lib/styles";

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  padding: 10px 0;
`;

const Wrapper = styled.div`
  ${globalInputStyles}
  padding: 2px 0 1px 0;
  position: relative;
  width: 100%;
`;

const ClearWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 100ms cubic-bezier(0.21, 0.94, 0.64, 0.99);
  span {
    margin: 0;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background: none;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    span {
      background: ${colors.lighterGray};
    }
  }
`;

type Props = {
  title?: string;
  date: string;
  onDateChange: (date: string) => void;
  style?: object;
};
const DateInput: React.FC<Props> = props => {
  const [focus, setFocus] = useState(false);

  return (
    <Outer style={props.style}>
      {props.title && <ItemTitle>{props.title}</ItemTitle>}
      <Wrapper>
        <CalendarIcon
          color={colors.gray}
          size={14}
          style={{
            position: "absolute",
            left: 14,
            bottom: 5
          }}
        />
        <SingleDatePicker
          id={`date-time-input-date-picker`}
          date={props.date ? moment(props.date) : null}
          numberOfMonths={1}
          focused={focus}
          small={true}
          onDateChange={date => {
            if (date) {
              props.onDateChange(moment(date).format("YYYY-MM-DD"));
            }
          }}
          onFocusChange={e => {
            setFocus(e.focused);
          }}
          placeholder={""}
          hideKeyboardShortcutsPanel={true}
        />
        {props.date && (
          <ClearWrapper onClick={() => props.onDateChange("")}>
            <CrossIcon size={14} color={colors.gray} />
          </ClearWrapper>
        )}
      </Wrapper>
      <style>
        {css`
          .SingleDatePickerInput_clearDate:hover,
          .SingleDatePickerInput_clearDate:focus {
            background: none;
            outline: none;
          }
          .SingleDatePickerInput {
            background: none;
            border: none;
            position: relative;
          }
          .DateInput {
            background: none;
          }
          .DateInput_input {
            border: none;
            color: ${colors.gray};
          }
          #date-time-input-date-picker {
            background: none;
            color: ${props.date ? colors.nearBlack : colors.gray};
            font-size: 14px;
            text-align: left;
            font-weight: 500;
            margin-left: 30px;
            padding-right: 0;
            width: 270px;
          }
          #discover-filter-date-picker::placeholder {
            color: ${colors.gray};
          }

          .CalendarDay:hover {
            background: ${colors.lighterGray};
          }
          .CalendarDay__selected,
          .CalendarDay__selected:hover {
            background: ${colors.primary};
            border: none;
          }
          .SingleDatePickerInput_clearDate {
            display: none;
          }
          .SingleDatePickerInput_clearDate_svg {
            fill: ${colors.white};
            margin-bottom: 3px;
            margin-left: 3px;
          }
        `}
      </style>
    </Outer>
  );
};
DateInput.defaultProps = {
  style: {}
};

export default DateInput;
